var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { Post } from "../../api/api";
import { Config } from "./config";
var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
var initialState = {
    permalink: undefined,
    accessToken: undefined
};
export var chitraSlice = createSlice({
    name: "Chitra",
    initialState: initialState,
    reducers: {
        setState: function (state, action) {
            var _a;
            var _b = action.payload, key = _b.key, value = _b.value;
            return _objectSpread(_objectSpread({}, state), {}, (_a = {},
                _a[key] = value,
                _a));
        },
        resetState: function (state, action) {
            var keysToReset = action.payload;
            keysToReset.forEach(function (key) {
                if (key in initialState) {
                    state[key] = initialState[key]; // Safely reset to initial state
                }
                else {
                    state[key] = initialState[key];
                    console.warn("Key \"".concat(key, "\" not found in initialState"));
                }
            });
        },
        setReducerState: function (state, action) {
            var _a = action.payload, key = _a.key, value = _a.value;
            state[key] = value;
        },
        deleteState: function (state, action) {
            var key = action.payload.key;
            delete state[key];
        },
        pushToArray: function (state, action) {
            var _a;
            var _state$key;
            var _b = action.payload, key = _b.key, value = _b.value;
            if (!((_state$key = state[key]) !== null && _state$key !== void 0 && _state$key.data))
                state[key] = _objectSpread(_objectSpread({}, state[key]), {}, {
                    data: []
                });
            (_a = state[key].data).push.apply(_a, value);
        }
    },
    extraReducers: function (builder) {
        builder.addCase(chitraTokenBackendAPI.pending, function (state) {
            state.isLoadingChitraTokenBackend = "loading"; // You can add a loading state if needed
        }).addCase(chitraTokenBackendAPI.fulfilled, function (state, action) {
            state.isLoadingChitraTokenBackend = "idle"; // Reset loading state
            // You can store the token in the state if needed
            state.accessToken = action.payload; // Store the token in state if needed
        }).addCase(chitraTokenBackendAPI.rejected, function (state) {
            state.isLoadingChitraTokenBackend = "failed"; // Set loading state to failed
        })
            // .addCase(getPermalinkAPINew.pending, (state) => {
            //     state.isLoadingGetPermalink = "loading"; // You can add a loading state if needed
            // })
            // .addCase(getPermalinkAPINew.fulfilled, (state, action) => {
            //     state.isLoadingGetPermalink = "idle"; // Reset loading state
            //     // You can store the permalink in the state if needed
            //     state.permalink = action.payload; // Store the permalink in state if needed
            // })
            // .addCase(getPermalinkAPINew.rejected, (state) => {
            //     state.isLoadingGetPermalink = "failed"; // Set loading state to failed
            // })
            .addCase(createPermalink.pending, function (state) {
            state.isLoadingGetPermalink = "loading"; // You can add a loading state if needed
        }).addCase(createPermalink.fulfilled, function (state, action) {
            state.isLoadingGetPermalink = "idle"; // Reset loading state
            // You can store the permalink in the state if needed
            state.permalink = action.payload; // Store the permalink in state if needed
        }).addCase(createPermalink.rejected, function (state) {
            state.isLoadingGetPermalink = "failed"; // Set loading state to failed
        });
    }
});
//Api calls when the backend was deployed using custom utility
// export const chitraTokenBackendAPI = createAsyncThunk<string, { userName: string; email: string }>(
//     "crud/chitraTokenBackend",
//     async ({ userName, email }, { dispatch }) => {
//         const payload = {
//             "user": userName,
//             "key": email
//         };
//         try {
//             const response: any = await Post(ChitraTokenUrl, payload);
//             if (response?.statusCode === 200) {
//                 const token = response?.data?.Token;
//                 const cookie = response?.data?.Cookie;
//                 localStorage.setItem("accessToken", token);
//                 localStorage.setItem("cookie", cookie);
//                 return token;
//             } else {
//                 throw new Error(`HTTP error! Status: ${response.statusCode}`);
//             }
//         } catch (error: any) {
//             console.log('catch', error)
//             // dispatch(showNotification({
//             //     isOpen: true,
//             //     message: handleServerSideErrors(error),
//             //     type: "error",
//             // }));
//             // GoogleAnlyticsErrorLog(profileData, ChitraTokenUrl, handleServerSideErrors(error), payload, error?.trace)
//             return ''; // Return an empty string in case of error
//         }
//     }
// );
// let headers: any = {
//     "Client-Id": Config.Chitra_clientId,
//     "Client-Secret": Config.Chitra_clientSecret,
//     Subscription: Config.Chitra_Subscription,
// };
// const options: CreateAxiosDefaults = {
//     headers,
//     timeout: 60000,
//     withCredentials: true,
// };
// const instance = axios.create(options);
// export const chitraCSRFTokenAPI = createAsyncThunk<string, { access_token: string }>(
//     "crud/chitraCSRFToken",
//     async ({ access_token }, { dispatch }) => {
//         console.log(access_token);
//         const headers = {
//             "Authorization": `Bearer ${access_token}`
//         }
//         try {
//             const response: any = await instance.get(`${Config.CHITRA_ENDPOINT}/api/v1/security/csrf_token`, { headers: headers });
//             console.log(response);
//             const csrf_token = response?.result;
//             return csrf_token
//         } catch (error: any) {
//             console.log('catch', error)
//             // dispatch(showNotification({
//             //     isOpen: true,
//             //     message: handleServerSideErrors(error),
//             //     type: "error",
//             // }));
//             // GoogleAnlyticsErrorLog(profileData, ChitraTokenUrl, handleServerSideErrors(error), payload, error?.trace)
//             return ''; // Return an empty string in case of error
//         }
//     }
// );
// export const getPermalinkAPINew = createAsyncThunk<string, { dashboardName: string; token: string }>(
//     "crud/getPermalinkNew",
//     async ({ dashboardName, token }, { dispatch }) => {
//         const payload = {
//             "dashboard_name": dashboardName,
//             "token": token,
//         };
//         try {
//             const response: any = await Post(PermalinkNew, JSON.stringify(payload));
//             if (response?.statusCode === 200) {
//                 const permalink = response?.data?.permalink;
//                 return permalink;
//             } else {
//                 throw new Error(`HTTP error! Status: ${response.statusCode}`);
//             }
//         } catch (error: any) {
//             console.log('catch', error)
//             // dispatch(showNotification({
//             //     isOpen: true,
//             //     message: handleServerSideErrors(error),
//             //     type: "error",
//             // }));
//             // GoogleAnlyticsErrorLog(profileData, PermalinkNew, handleServerSideErrors(error), payload, error?.trace)
//             return ''; // Return an empty string in case of error
//         }
//     }
// );
//Api calls directly accessng Superset Api's
export var chitraCSRFTokenAPI = createAsyncThunk("crud/chitraCSRFToken", function (_ref, _ref2) { return __awaiter(void 0, void 0, void 0, function () {
    var access_token, dispatch, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                access_token = _ref.access_token;
                dispatch = _ref2.dispatch;
                return [4 /*yield*/, fetch("".concat(Config.CHITRA_ENDPOINT, "/api/v1/security/csrf_token"), {
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer ".concat(access_token)
                        }
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.result];
        }
    });
}); });
// export const chitraCSRFTokenAPI = createAsyncThunk<string, { access_token: string }>(
//     "crud/chitraCSRFToken",
//     async ({ access_token }, { dispatch }) => {
//         console.log(access_token);
//         const headers = {
//             "Authorization": `Bearer ${access_token}`
//         }
//         try {
//             const response: any = await Get(`${Config.CHITRA_ENDPOINT}/api/v1/security/csrf_token`, { headers: headers });
//             console.log(response);
//             const csrf_token = response?.result;
//             return csrf_token
//         } catch (error: any) {
//             console.log('catch', error)
//             // dispatch(showNotification({
//             //     isOpen: true,
//             //     message: handleServerSideErrors(error),
//             //     type: "error",
//             // }));
//             // GoogleAnlyticsErrorLog(profileData, ChitraTokenUrl, handleServerSideErrors(error), payload, error?.trace)
//             return ''; // Return an empty string in case of error
//         }
//     }
// );
export var chitraTokenBackendAPI = createAsyncThunk("crud/chitraTokenBackend", function (_ref3, _ref4) { return __awaiter(void 0, void 0, void 0, function () {
    var userName, email, dispatch, payload, response, access_token, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                userName = _ref3.userName, email = _ref3.email;
                dispatch = _ref4.dispatch;
                payload = {
                    "provider": "db",
                    "refresh": true,
                    "username": userName,
                    "password": email
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Post("".concat(Config.CHITRA_ENDPOINT, "/api/v1/security/login"), payload)];
            case 2:
                response = _a.sent();
                access_token = response === null || response === void 0 ? void 0 : response.access_token;
                return [2 /*return*/, access_token];
            case 3:
                error_1 = _a.sent();
                console.log('catch', error_1);
                // dispatch(showNotification({
                //     isOpen: true,
                //     message: handleServerSideErrors(error),
                //     type: "error",
                // }));
                // GoogleAnlyticsErrorLog(profileData, ChitraTokenUrl, handleServerSideErrors(error), payload, error?.trace)
                return [2 /*return*/, '']; // Return an empty string in case of error
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getDashboardIds = createAsyncThunk("crud/getDashboardIds", function (_ref5, _ref6) { return __awaiter(void 0, void 0, void 0, function () {
    var access_token, csrf_token, dispatch, page, dashboards, result, target_dashboard;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                access_token = _ref5.access_token, csrf_token = _ref5.csrf_token;
                dispatch = _ref6.dispatch;
                page = 0;
                dashboards = [];
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchDashboardData(page, access_token, csrf_token)];
            case 2:
                result = _a.sent();
                if (!result || result.length === 0)
                    return [3 /*break*/, 3];
                dashboards = dashboards.concat(result);
                page++;
                return [3 /*break*/, 1];
            case 3:
                target_dashboard = dashboards.map(function (item) { return ({
                    id: item.id,
                    dashboard_title: item.dashboard_title
                }); });
                return [2 /*return*/, target_dashboard];
        }
    });
}); });
function fetchDashboardData(page, token, csrfToken) {
    return __awaiter(this, void 0, void 0, function () {
        var params, encoded, url, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        page: page,
                        page_size: 100
                    };
                    encoded = encodeURIComponent(JSON.stringify(params));
                    url = "".concat(Config.CHITRA_ENDPOINT, "/api/v1/dashboard/?q=").concat(encoded);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                "Authorization": "Bearer ".concat(token),
                                "Content-Type": "application/json",
                                "Referer": Config.CHITRA_ENDPOINT,
                                "X-CSRFToken": csrfToken
                            },
                            params: params
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response.data.result];
                case 3:
                    err_1 = _a.sent();
                    console.error("Failed to fetch dashboards: ".concat(err_1.message));
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export var createPermalink = createAsyncThunk("crud/getPermalinkNew", function (_ref7, _ref8) { return __awaiter(void 0, void 0, void 0, function () {
    var dashboardId, token, csrfToken, dispatch, url, payload, response, permalink, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dashboardId = _ref7.dashboardId, token = _ref7.token, csrfToken = _ref7.csrfToken;
                dispatch = _ref8.dispatch;
                url = "".concat(Config.CHITRA_ENDPOINT, "/api/v1/dashboard/").concat(dashboardId, "/permalink");
                payload = {
                    urlParams: [["standalone", "true"]],
                    activeTabs: []
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post(url, payload, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "X-CSRFToken": csrfToken,
                            "Content-Type": "application/json",
                            Referer: Config.CHITRA_ENDPOINT
                        }
                    })];
            case 2:
                response = _a.sent();
                if (response.status === 201) {
                    permalink = response.data.key;
                    return [2 /*return*/, permalink];
                }
                console.error("Failed to create permalink: ".concat(response.status, " ").concat(response.statusText));
                return [2 /*return*/, null];
            case 3:
                err_2 = _a.sent();
                console.error("Error creating permalink:", err_2.message);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var setState = (_a = chitraSlice.actions, _a.setState), resetState = _a.resetState, setReducerState = _a.setReducerState, deleteState = _a.deleteState, pushToArray = _a.pushToArray;
var chitraReducer = chitraSlice.reducer;
export default chitraReducer;
